"use strict";

require("core-js/modules/es.regexp.exec");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mimeTypes = _interopRequireDefault(require("mime-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FileUtils = /*#__PURE__*/function () {
  function FileUtils() {
    _classCallCheck(this, FileUtils);
  }

  _createClass(FileUtils, null, [{
    key: "getExtension",
    value: function getExtension(mime) {
      if (!mime) {
        return '';
      }

      switch (mime) {
        case 'application/x-zip':
        case 'application/x-zip-compressed':
          return 'zip';

        default:
          return _mimeTypes.default.extension(mime);
      }
    }
  }, {
    key: "getExtensionFromFileName",
    value: function getExtensionFromFileName(fileName) {
      if (!fileName) {
        return null;
      }

      var extensionRegex = /(?:\.([^.]+))?$/; // https://stackoverflow.com/questions/680929/how-to-extract-extension-from-filename-string-in-javascript

      return extensionRegex.exec(fileName)[1];
    }
  }, {
    key: "getMimeType",
    value: function getMimeType(extension) {
      var type = _mimeTypes.default.lookup(extension);

      if (!type) {
        switch (extension) {
          case 'cal':
            return 'application/octet-stream';

          default:
            return '';
        }
      }

      return type;
    }
  }]);

  return FileUtils;
}();

exports.default = FileUtils;
//# sourceMappingURL=FileUtils.js.map